import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const GameReportLink = styled.a`
    height: 54px;
    border-top: 1px solid ${({ theme }) => theme.Surface.border};
    ${BaseStyle.Mixins.fontStyles.table.regular}
    &&:link {
        color: ${({ theme }) => theme.Utility.cta};
    }
    padding: 20px 16px;
`;

export const LinksWrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid ${({ theme }) => theme.Surface.border};
`;
